import { error_404 } from 'assets/gif';
import { Button } from 'components';
import Typography from 'components/shared/Typography';
import { useEffect } from 'react';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const fullUrl = `${window?.location?.origin}${location?.pathname}${location?.search}`;

  const splittedParams = fullUrl?.split('/');

  const countReports = fullUrl?.split('/').filter((param) => param === 'reports').length;

  const id = splittedParams[splittedParams?.length - 1] as string;

  useEffect(() => {
    if (countReports > 1) {
      navigate(`/reports/${id}`);
    }
  }, [countReports, id, navigate]);

  return (
    <>
      <div className='flex flex-col items-center justify-between h-screen py-32'>
        <div className='flex flex-col gap-2 justify-center items-center'>
          <Typography variant='displayxl' className='text-shade-black' weight='bold'>
            Oops!
          </Typography>{' '}
          <Typography variant='textmd' className='text-shade-black mb-2' weight='regular'>
            we couldn't find the page you're looking for.
          </Typography>{' '}
        </div>
        <img src={error_404} alt='not found' />
        <Button title='Go Back' icon={<FaArrowLeftLong />} className='rounded-full' onClick={() => navigate(-1)} />
      </div>
      ;
    </>
  );
}
